import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HolidayDateModel, HolidayModel } from './holiday.model';

@Injectable({
  providedIn: 'root',
})
export class HolidayService {
  constructor(private httpClient: HttpClient, private toastrService: ToastrService) { }

  deleteHoliday(id: number) {
    return this.httpClient.post(`${AppConfig.settings.settings.apiEndpoint}api/Holiday/DeleteHoliday/${id}`, null)
      .pipe(map(() => {
        this.toastrService.success('Holiday deleted successfully.', 'Success');
      }));
  }

  deleteHolidayDate(id: number) {
    return this.httpClient.post(`${AppConfig.settings.settings.apiEndpoint}api/Holiday/DeleteHolidayDate/${id}`, null)
      .pipe(map(() => {
        this.toastrService.success('Holiday Date deleted successfully.', 'Success');
      }));
  }

  getHolidayDates(year: string): Observable<HolidayDateModel[]> {
    return this.httpClient.post<HolidayDateModel[]>(`${AppConfig.settings.settings.apiEndpoint}api/Holiday/GetHolidayDates?year=${year}`, null)
      .pipe(map(value => {

        return value;
      }));
  }

  getHolidays(): Observable<HolidayModel[]> {
    return this.httpClient.get<HolidayModel[]>(`${AppConfig.settings.settings.apiEndpoint}api/Holiday/GetHolidays`).pipe(
      map(value => {
        return value;
      }));
  }

  insertOrUpdateHoliday(holiday: HolidayModel): Observable<number> {
    return this.httpClient.post<number>(`${AppConfig.settings.settings.apiEndpoint}api/Holiday/InsertOrUpdateHoliday`, holiday)
      .pipe(map(value => {
        if (value === 0) {
          this.toastrService.error('Holiday already exists.', 'Error');
        } else this.toastrService.success('Saved Successfully', 'Success');

        return value;
      }));
  }

  insertOrUpdateHolidayDate(holidayDate: HolidayDateModel): Observable<number> {
    return this.httpClient.post<number>(`${AppConfig.settings.settings.apiEndpoint}api/Holiday/InsertOrUpdateHolidayDate`, holidayDate)
      .pipe(map(value => {
        if (value === 0) {
          this.toastrService.error('Holiday Date already exists.', 'Error');
        } else this.toastrService.success('Saved Successfully', 'Success');

        return value;
      }));
  }
}
